import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@material-ui/core";
import Header from "@app/components/header";
import { Content } from "@app/components/content";
import { ERROR_SCREEN } from "@app/utils/constants";
import { ReactComponent as UnexpectedErrorIconSVG } from "@app/assets/unexpected-error.svg";
import { ReactComponent as UnexpectedErrorOutlineIconSVG } from "@app/assets/unexpected-error-outline.svg";
import useStyles from "./style";
import { useHistory } from "react-router-dom";
import { getOEMConfig } from "@app/utils/OemUtils";
import { useQueryParams } from "@app/pages/iv-user-registration/hooks/useQueryParams";

interface Props {
    header: string;
    message: string;
    SvgErrorIcon: React.FC<React.SVGProps<SVGSVGElement>>;
    SvgErrorOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>>;
    displayButton: boolean;
    ivUserScreen: boolean;
}

const IVUserScreenURL = ["/verification", "/ivuserregistration", "/recover-password", "/feedback"];

const ErrorMessage = (props: Props): JSX.Element => {
    const classes = useStyles();
    const history = useHistory();

    const { header, message, SvgErrorIcon, displayButton, SvgErrorOutlineIcon, ivUserScreen } =
        props;
    const [headerText, setHeaderText] = useState(header);
    const [messageText, setMessageText] = useState(message);

    useEffect(() => {
        const handleTokenInvalid = () => {
            setHeaderText(ERROR_SCREEN.INVALID_TOKEN.HEADER_TEXT);
            setMessageText(ERROR_SCREEN.INVALID_TOKEN.DETAILED_TEXT);
        };

        window.addEventListener("tokenInvalid", handleTokenInvalid);

        return () => {
            window.removeEventListener("tokenInvalid", handleTokenInvalid);
        };
    }, []);

    return (
        <>
            {ivUserScreen ? (
                <SvgErrorOutlineIcon test-data-id="error-icon" />
            ) : (
                <SvgErrorIcon test-data-id="error-icon" />
            )}
            <Typography className={classes.header} variant="h5" align="center" paragraph={true}>
                <strong>{headerText}</strong>
            </Typography>
            <Typography
                className={classes.detailText}
                variant="inherit"
                align="center"
                paragraph={true}
            >
                <span className="detail-text">{messageText}</span>
            </Typography>
            {displayButton && (
                <Button
                    className={classes.createButton}
                    onClick={() => history.goBack()}
                    variant="contained"
                    size="small"
                    color="primary"
                >
                    Go Back
                </Button>
            )}
        </>
    );
};

// Common component to display respective error message and icon
const ErrorComponent = (props: { isErrorPage?: boolean; displayButton?: boolean }) => {
    const history = useHistory();
    const { brand = "" } = useQueryParams();
    const { logo: LogoComponent } = getOEMConfig(brand as string);
    let ivUserScreen = false;

    IVUserScreenURL.forEach((url) => {
        if (history?.location?.pathname?.indexOf(url) >= 0) ivUserScreen = true;
    });

    const classes = useStyles();

    const defaultProps = {
        header: ERROR_SCREEN.UNEXPECTED_ERROR.HEADER_TEXT,
        message: ERROR_SCREEN.UNEXPECTED_ERROR.DETAILED_TEXT,
        SvgErrorIcon: UnexpectedErrorIconSVG,
        SvgErrorOutlineIcon: UnexpectedErrorOutlineIconSVG,
        displayButton: props?.displayButton || false,
        ivUserScreen,
    };

    if (props?.isErrorPage) {
        return (
            <React.Fragment>
                {!ivUserScreen ? (
                    <Header fromRegister={false} />
                ) : (
                    <div className={classes.ivScreenDiv}>
                        <LogoComponent />

                    </div>
                )}
                <Content className={ivUserScreen ? classes.ivuserScreen : ""}>
                    <Grid
                        className={ivUserScreen ? classes.ivRoot : classes.root}
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid className={"boxColor"}>
                            <ErrorMessage
                                {...(props as unknown as Props)}
                                ivUserScreen={ivUserScreen}
                            />
                        </Grid>
                    </Grid>
                </Content>
            </React.Fragment>
        );
    }

    return (
        <Content className={classes.emptyContentBox}>
            <Box className={classes.emptyBox}>
                <ErrorMessage {...defaultProps} />
            </Box>
        </Content>
    );
};

export default ErrorComponent;
